import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarRange } from "lucide-react";
import api from "@/lib/api";

const TYPE_DOT = { holiday: "bg-ink", celebration: "bg-gold", recognition: "bg-white border border-ink" };

export const UpcomingObservances = ({ className = "" }) => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/observances/upcoming", { params: { days: 7 } }).then((r) => setItems(r.data.items)).catch(() => setItems([]));
  }, []);

  if (!items || items.length === 0) return null;

  return (
    <section data-testid="upcoming-observances" className={`rounded-2xl border border-[#e5e7eb] bg-white p-5 sm:p-6 ${className}`}>
      <div className="flex items-center gap-2 mb-4">
        <CalendarRange className="w-4 h-4 text-gold" />
        <p className="text-[11px] font-bold uppercase tracking-[0.15em] text-gold">Coming up this week</p>
      </div>
      <ul className="divide-y divide-[#f1f1f1]">
        {items.map((o) => (
          <li key={o.date_dd_mm} data-testid={`upcoming-${o.date_dd_mm}`}>
            <Link to={`/?date=${o.date_dd_mm}#observance`} className="group flex items-start gap-3 py-2.5 hover:text-gold transition-colors">
              <span className="w-24 shrink-0 text-[12px] text-ink-muted pt-0.5">{o.weekday.slice(0, 3)} {o.date_label}</span>
              <span className={`mt-1.5 w-2 h-2 rounded-full shrink-0 ${TYPE_DOT[o.type] || TYPE_DOT.celebration}`} />
              <span className="min-w-0 flex-1">
                <span className="block text-[14px] font-semibold text-ink group-hover:text-gold transition-colors">{o.name}</span>
                <span className="block text-[11px] text-ink-muted">{o.type_label}</span>
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
};
